import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import WorkInProgressAlert from "@/components/common/Alerts/WorkInProgressAlert"

export const Route: AnyRoute = createFileRoute("/app/sales/")({
  component: () => <WorkInProgressAlert />,
})
